/**
 * SQLite operations to track changes for with {@link TriggerManager}
 *
 * @experimental @alpha
 */
export var DiffTriggerOperation;
(function (DiffTriggerOperation) {
    DiffTriggerOperation["INSERT"] = "INSERT";
    DiffTriggerOperation["UPDATE"] = "UPDATE";
    DiffTriggerOperation["DELETE"] = "DELETE";
})(DiffTriggerOperation || (DiffTriggerOperation = {}));
//# sourceMappingURL=TriggerManager.js.map